import { err, ok, Result } from 'resulty';

export const whenGreaterThanOrEqualTo =
  <T>(target: T) =>
  (value: T): Result<string, T> =>
    value >= target ? ok(value) : err(`Expected ${value} to be greater than or equal to ${target}`);

export const whenEqualTo =
  <T>(target: T) =>
  (value: T): Result<string, T> =>
    value === target ? ok(value) : err(`Expected ${value} to be equal to ${target}`);
